import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./brands-collections-results.${locale}.json`));
